import { useEffect, useState } from "react";
import axios from "axios";
import useSearchPagination from "../../../hooks/useSearchPagination";
import { API_URL } from '../../../api/api';

const MyLeaveRequests = () => {
  const token = localStorage.getItem("token");

  const [requests, setRequests] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  // Fetch leave requests
 useEffect(() => {
  if (!token) return;

  const fetchRequests = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/leaves/my-requests`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRequests(res.data || []);
    } catch (err) {
      console.error('Failed to load leave requests', err);
    }
  };

  fetchRequests();
}, [token]);

  // Use shared search + pagination hook
  const { filteredData, currentData, totalPages } =
    useSearchPagination(requests || [], searchTerm, currentPage);

  return (
    <div className="leave-requests-page">


<div className="title-search">
<h1>My Leave Requests</h1>
<div className="search-item">
              <input
            type="text"
            placeholder="Search by leave type, status, reason"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            className="search-icon"
          />
</div></div>



      {/* Table */}
      <div className="resp-table">
      <table className="leave-table">
        <thead>
          <tr>
            <th>Leave Type</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Reason</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {currentData.length > 0 ? (
            currentData.map((req) => (
              <tr key={req.id}>
                <td>{req.leave_type}</td>
                <td>{new Date(req.start_date).toLocaleDateString()}</td>
                <td>{new Date(req.end_date).toLocaleDateString()}</td>
                <td>{req.reason || "-"}</td>
                <td>
                  <span className={`status-badge ${req.status}`}>
                    {req.status}
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                No leave requests found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

      {/* Pagination */}
        {/* Pagination */}
      <div className="pagination">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
        >
          Prev
        </button>

        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i + 1}
            className={currentPage === i + 1 ? "active" : ""}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
        >
          Next
        </button>
      </div>
      
    </div>
  );
};

export default MyLeaveRequests;
